module.exports = __webpack_public_path__ + "9306ea34eb6db9ae24cc969fd0ea5696.png";